<template>
        <a-card class="card-border" style="border: 0px; border-bottom: 1px solid #e1e4e8;" :bodyStyle="{padding: '10px', textAlign: 'left'}">
          <a-row>
            <a-row style="width: 280px;position: absolute; top: 0px; right: 50px; z-index: 4; display: none;">
              <!-- a-select mode="tags" @change="selectTags" size="small" style="width: 225px;">
                <a-select-option v-for="(tags, index) in user_tags" :key="index" :value="tags.value">
                {{tags.name}}
                </a-select-option>
              </a-select -->
              <a-tree-select
                style="width: 225px"
                :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                :treeData="user_tags"
                placeholder=''
                allowClear
                multiple
                treeDefaultExpandAll
                @change="selectTags"
                >
                  <span style="color: #08c" slot="title" slot-scope="{key, value}">
                    {{value}}
                  </span>
              </a-tree-select>
              <a-button style="height: 32px;" @click="addProfileTags($event)">
                <a-icon type="plus"/>
              </a-button>
            </a-row>
            <a-col :span="20" :key="refresh">
              <h3>
                <a @click="showDetails()" style="display: inline-block;margin-right: 8px;"> {{item.entname}} </a>
                <a-tag closable @close="deleteProfileTags(index)" v-for="(tags, index) in item.profile.tags" :key="index">
                    {{tags.tags}}
                </a-tag>
              </h3>
            </a-col>
            <a-col :span="4" style="text-align: right">
              <a @click="showInputTags($event)" style="margin-right: 16px; z-index: 5;">
                <a-icon type="tag" style="font-size: 16px;" />
              </a>
              <a-checkbox @change="linkChange($event)" :key="refresh" :checked="item.checked"></a-checkbox>
            </a-col>
          </a-row>
          <a-row class="mb4">
            <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <b>法人代表</b>：{{item.reprezen}}
            </a-col>
            <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <b>信用代码</b>：{{item.credit_code}}
            </a-col>
            <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <b>注册资金</b>：{{item.reged_cap}} 万元
            </a-col>
            <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <b>注册时间</b>：{{item.esdate | TimeChange}}
            </a-col>
          </a-row>
          <a-row class="mb4">
            <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <b>企业地址</b>：{{item.address}}
            </a-col>
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <b>企业状态</b>：{{item.entstatus}}
            </a-col>
          </a-row>
          <a-row class="mb4">
            <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <b>行业分类</b>：{{item.industry}}/{{item.subindustry}}
            </a-col>
            <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <b>所属区域</b>：{{item.province}}/{{item.city}}/{{item.county}}
            </a-col>
          </a-row>
          <a-row  class="mb4" v-if="item.showdetail">
            <a-col :span="24" v-if="item.website && item.website != '1'">
              <b>网址</b>：<span style="word-wrap:break-word;" 
                      v-for="(url, order) in item.website"><a :href="url" :key="order" target="_blank">{{url}}</a>&nbsp;</span>
            </a-col>
            <a-col :span="24" v-if="item.email && item.email != '1'">
              <b>邮箱</b>：<span style="word-wrap:break-word;" 
                      v-for="(url, order) in item.email"><a :href="'mailto:' + url" :key="order">{{url}}</a>&nbsp;</span>
            </a-col>
            <a-col :span="24" v-if="item.phone && item.phone != '1'">
              <b>固话</b>：{{item.phone}}
            </a-col>
            <a-col :span="24" v-if="item.mobile && item.mobile != '1'">
              <b>手机</b>：{{item.mobile}}
            </a-col>
            <a-col :span="24" v-if="item.qq && item.qq != '1'">
              <b>QQ</b>：{{item.qq}}
            </a-col>
          </a-row>
          <a-row class="mb4">
            <a-col :span="24" v-if="item.opscope && item.showdetail">
              <b>经营范围</b>：{{item.opscope}} 
            </a-col>
          </a-row>
          <a-row>
            <p class="text-all" v-if="item.intro && showdetail == true" v-html="'<b>企业简介</b>：' + item.intro"></p>
            <p class="text-abbred" v-if="item.intro && showdetail == false"  v-html="'<b>企业简介</b>：' + item.intro"></p>
          </a-row>
          <a-row v-if="item.intro && item.showdetail && item.custom">
            <pre style="overflow: hidden">
              {{item.custom}}
            </pre>
          </a-row>
          <comments @following="followItem" @deleteitem="deleteComments" @additem="addComments"  @topitem="topComments" @resetitem="resetComments":key="refresh" :item="item"  :Ent_tag="1"/>
        </a-card>
</template>

<script>
import {Comments, Tags} from '@/com/Basic'

export default {
  name: 'EntItem',
  props: {
    item: {
      type: Object,
      default: function() {
        return {}
      }
    },
    index: {
      type: Number,
      default: function() {
        return 0
      }
    }
  },
  data() {
      return {
          showdetail: this.item.showdetail,
          refresh: 1,
          user_tags: [],
          select_tags: [],
          input_tags: ""
      }
  },
  components: {
    Tags,
    Comments,
  },
  filters: {
    TimeChange(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + MM + "-" + d;
   }
  },
  methods: {
    showInputTags: function(e) {
      let elem = e.target.localName
      let node = ""
      if (elem == "path") {
        node = e.target.parentNode.parentNode.parentNode.parentNode.parentNode.childNodes[0]
      }
      if (elem == "svg") {
        node = e.target.parentNode.parentNode.parentNode.parentNode.childNodes[0]
      }
      node.childNodes[0].value = ""
      let show = node.style.display
      if (show == "block") {
        node.style.display = "none"
        return;
      }
      let postdata = {
        task: "ICI_USER_TAGS",
        utags: "true"
      }
      let that = this
      that.post('enterprise', postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.user_tags = data.data
            that.$nextTick(function() {
              node.style.display = "block"
            });
          }
        }).catch(function (e) {
          console.log(e)
      });
    },
    selectTags: function(value, label, extra){
      this.select_tags = value;
    },
    deleteProfileTags: function(order) {
      let item = this.item
      let postdata = {
        task: "DELETE_PROFILE_TAGS",
        type: "ent",
        source: item.entname,
        order: order
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          let tp = item["profile"];
          let tags = [];
          for (let i = 0; i < tp.tags.length; i++) {
            if (i != Number(order)) {
              tags.push(tp.tags[i]);
            }
          }
          item["profile"]["tags"] = tags;
          that.item = item
          that.$store.commit('updateresultitem', {result: that.item, index: that.index});
          that.refresh += 1;
        }).catch(function (e) {
          console.log(e);
          that.$message.error("删除失败");
      })
    },
    addProfileTags: function(e) {
      //let tags = e.target.parentNode.childNodes[0].value
      let tags = this.select_tags;
      let item = this.item
      if (tags.length == 0) {
        return;
      }
      let postdata = {
        task: "ADD_PROFILE_TAGS",
        type: "ent",
        source: item.entname,
        tags: tags
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          //e.target.parentNode.childNodes[0].value = ""
          if (!item.profile) {
            item.profile = {};
          }
          if (!item.profile.tags) {
            item.profile.tags = [];
          }
          for (let j = 0; j < tags.length; j++) {
            let dup = true;
            for (let i = 0; i < item.profile.tags.length; i++) {
              if (tags[j] == item.profile.tags[i].tags) {
                dup = false;
              }
            }
            if (dup) {
              item.profile.tags.push({"tags": tags[j]});
            }
          }
          that.item = item;
          that.$store.commit('updateresultitem', {result: that.item, index: that.index});
          that.refresh += 1;
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败");
      })
    },
    linkChange: function(e) {
      let item = this.item
      if (e.target.checked) {
         this.$emit('linkchange', this.item.entname, true);
         item["checked"] = true;
         this.$set(item, 'checked', true);
      } else {
         this.$emit('linkchange', this.item.entname, false);
         item["checked"] = false;
         this.$set(item, 'checked', false);
      }
      this.item = item
      this.$store.commit('updateresultitem', {result: this.item, index: this.index});
      this.refresh += 1;
    },
    followItem: function(item, value) {
      item.profile['like'] = value;
      let postdata = {
            "task": "ADD_PROFILE_LIKE",
             type: 'ent',
             source: item.entname,
             like: value
          };
      let that = this;
      that.post("profile", postdata)
        .then(function(response) {
          that.item = item;
          that.$store.commit('updateresultitem', {result: that.item, index: that.index});
          that.refresh += 1;
        }).catch(function (e) {
          that.$message.error('修改失败');
     });
    },
    addComments: function(content, item) {
      let postdata = {
        task: "ADD_PROFILE_COMMENT",
        type: "ent",
        source: item.entname,
        content: content
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          if (!item.profile) {
            item.profile = {};
          }
          if (!item.profile.comments) {
            item.profile.comments = [];
          }
          item.profile.comments.unshift({"content": content, "top": 0, "time": (new Date()).valueOf()});

          item.profile.comments.sort((a, b) => {
            return b.time - a.time;
          });
          item.profile.comments.sort((a, b) => {
            return b.top - a.top;
          });

          that.item = item;
          that.$store.commit('updateresultitem', {result: that.item, index: that.index});
          that.refresh += 1;
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败");
      })
    },

    topComments: function(order) {
      let item = this.item;
      let temp = item.profile.comments[order];
      let start = 0;
      let end = order;
      for (let i = end; i > start; i--) {
        item.profile.comments[i] = item.profile.comments[i - 1]
      }
      temp.top = 1;
      item.profile.comments[start] = temp;
      //order = item.profile.comments.length - order - 1;
      let postdata = {
        task: "TOP_PROFILE_COMMENT",
        type: "ent",
        source: item.entname,
        order: order,
        top: 1
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.item = item;
            item.profile.comments.sort((a, b) => {
            return b.time - a.time;
            });
            item.profile.comments.sort((a, b) => {
              return b.top - a.top;
            });
            that.$store.commit('updateresultitem', {result: that.item, index: that.index});
            that.refresh += 1;
          } else {
            that.$message.error("添加失败");
          }
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败");
      })
    
    },

    resetComments: function(order) {
      let item = this.item;
      let tp = item["profile"];
      let comments = [];
      //console.log(JSON.stringify(tp, "", "    "))

      for (let i = 0; i < tp.comments.length; i++) {
            if (i == Number(order)) {
              tp.comments[i].top = 0;
              comments.push(tp.comments[i]);
            }
            else{
              comments.push(tp.comments[i]);
            }
            }
      comments=tp.comments.sort((a, b) => {
        return b.time - a.time;
      });
      comments=tp.comments.sort((a, b) => {
        return b.top - a.top;
      });
      item["profile"]["comments"] = comments;
      let postdata = {
        task: "TOP_PROFILE_COMMENT",
        type: "ent",
        source: item.entname,
        order: order,
        top: 0
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          if (data.ret == 200) {
            that.item = item;
            that.$store.commit('updateresultitem', {result: that.item, index: that.index});
            that.refresh += 1;
          } else {
            that.$message.error("添加失败");
          }
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败");
      })    
    },

    deleteComments: function(item, order) {
      let postdata = {
        task: "DELETE_PROFILE_COMMENT",
        type: "ent",
        source: item.entname,
        order: order
      };
      let that = this;
      that.post("profile", postdata)
        .then(function(data) {
          let tp = item["profile"];
          let comments = [];
          for (let i = 0; i < tp.comments.length; i++) {
            if (i != Number(order)) {
              comments.push(tp.comments[i]);
            }
          }
          item["profile"]["comments"] = comments;
          that.item = item
          that.$store.commit('updateresultitem', {result: that.item, index: that.index});
          that.refresh += 1;
        }).catch(function (e) {
          console.log(e);
          that.$message.error("添加失败");
      })
    },
    showDetails: function() {
      let item = this.item;
      if (item["showdetail"] && item["showdetail"] == true) {
        item["showdetail"] = false;
        this.showdetail = false;
        this.item = item;
        return;
      }
      if (item["showdetail"] && item["showdetail"] == false) {
        item["showdetail"] = true;
        this.showdetail = true;
        this.item = item
        return;
      }
      let entname = item.entname;
      let postdata = {
        "task": "ICI_TASK_REGINFO",
        "entname": entname
      };
      let that = this;
      let loading = that.$message.loading("详细数据获取中...", 0);
      that.post('enterprise', postdata)
        .then(function(data) {
          setTimeout(loading, 0);
          data.data["custom"] = that.item['custom'];
          data.data["like"] = item.like ? item.like: 0;
          data.data["profile"] = item.profile ? item.profile: {};
          data.data["showdetail"] = true;
          that.showdetail = true;
          if (data.data.website) 
            data.data.website = data.data.website.split(" "); 
          if (data.data.email) 
            data.data.email = data.data.email.split(" "); 

          that.item = data.data;
          that.$store.commit('updateresultitem', {result: data.data, index: that.index});
        }).catch(function (e) {
          setTimeout(loading, 0);
          that.$message.error("查询失败");
      });
    }
  }
}
</script>

<style scoped>
  .pb8 {
    padding-bottom: 8px;
  }

  .card-border {
    border-top: 0px;
    border-bottom: 1px solid #e1e4e8;
    border-left: 0px;
    border-right: 0px;
  }

  .text-abbred{
    font-size: 14px;
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }

  .mb4 {
    margin-bottom: 4px;
  }

  /deep/ :root .ant-tag .anticon-close { 
    color: #808080; 
  }

</style>

<style>

  li /deep/ .ant-select-tree-treenode-switcher-open 
  { 
    margin: 0px 0px; 
  }

  li /deep/ .ant-select-tree-treenode-selected
  { 
    margin: 0px 0px; 
  }

  .ant-select-tree-treenode-switcher-open .ant-select-tree-treenode-selected .ant-select-tree li
  { 
    margin: 0px 0px; 
  }

</style>
